// React
import React from "react";
// Table related
import FullTable from "common/ui/components/table/FullTable";
import * as RenderAs from "common/ui/components/table/renderAs";
import * as ColumnHeading from "common/ui/components/table/columnHeading";
import { ColumnSize, ColumnMeta } from "common/ui/components/table/ColumnMeta";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export default class LeadsReportView extends React.Component {
    constructor(props) {
        super(props);
        this.updateStateAgentNames = (props) => {
            let { report } = props;
            if (!report)
                return;
            let { reportData } = report;
            if (!reportData)
                return;
            let agentNames = reportData.items.map((item) => item.toName);
            let uniqueAgentNames = Array.from(new Set(agentNames));
            this.setState({ agentNames: uniqueAgentNames });
        };
        this.state = { agentNames: [] };
    }
    componentDidMount() {
        this.updateStateAgentNames(this.props);
    }
    componentWillReceiveProps(nextProps, nextContext) {
        this.updateStateAgentNames(nextProps);
    }
    render() {
        let { items } = this.props;
        //-- Column meta data
        let metaData = [];
        metaData.push(new ColumnMeta(1, "dateTime", "Sent At", ColumnSize.col5).sortOrder(["desc", "asc"]).headerProps({ tip: "The date the lead was sent" }).toReportColumnMeta());
        metaData.push(new ColumnMeta(3, "toName", "To", ColumnSize.auto).header(ColumnHeading.leadToHeader).headerProps({ tip: "To whom the lead was sent", agentNames: this.state.agentNames }).toReportColumnMeta());
        metaData.push(new ColumnMeta(4, "channel", "Lead Type", ColumnSize.col5).header(ColumnHeading.leadChannelHeader).headerProps({ tip: "Type of message lead: Email or Call Me Back" }).toReportColumnMeta());
        metaData.push(new ColumnMeta(5, "reason", "Regarding", ColumnSize.col5).header(ColumnHeading.leadReasonHeader).headerProps({ tip: "What the lead message is regarding" }).toReportColumnMeta());
        metaData.push(new ColumnMeta(6, "portalRef", "Ref", ColumnSize.col4).headerProps({ tip: "The Listing Portal Reference the lead is sent from (if applicable)" }).toReportColumnMeta());
        metaData.push(new ColumnMeta(7, "fromName", "From", ColumnSize.auto).headerProps({ tip: "The name of the person who sent the lead" }).toReportColumnMeta());
        metaData.push(new ColumnMeta(8, "fromEmail", "From Email", ColumnSize.auto).component(RenderAs.renderAsEmail).headerProps({ tip: "The email address of the person who sent the lead (if supplied)" }).toReportColumnMeta());
        metaData.push(new ColumnMeta(9, "fromMobile", "From Mobile", ColumnSize.col5).headerProps({ tip: "The mobile number of the person who sent the lead (if supplied)" }).toReportColumnMeta());
        metaData.push(new ColumnMeta(10, "message", "Message", ColumnSize.auto).component(RenderAs.renderAsClickableModal).headerProps({ tip: "The contents of the message" }).notSortable().toReportColumnMeta());
        //-- Return
        return (React.createElement("div", null,
            React.createElement(FullTable, { reportItems: items, metaData: metaData, excludeColumns: ["listingAddress"], excludeColumnsFromFilter: ["message", "listingAddress"], initialSort: "dateTime" })));
    }
}
